import React from 'react'

import Layout from './index'

export default (props) => {
  return (
    <Layout
      {...props}
      locale="en-US"
    />
  );
}



export const query = graphql`
query SiteTitleQueryEn {
  site: site {
    siteMetadata {
      title
    }
  }

  mailingListForm: contentfulSubmitForm(id: {eq: "c4nxseH8UreamKuCaA0IE6q" }) {
    actionUrl
    formId
    layout
    u
  }

  applyButton: contentfulApplyButton(node_locale: {eq: "en-US"}) {
    id
    node_locale
    showApplyBtn
    cta {
      id
      title
      url
    }
  }

  metaDescription: contentfulLocalizationString(key: {eq: "meta.description"}, node_locale: {eq: "en-US"}) {
    text
  }

  mainNavigation: contentfulPageList(id: {eq: "c4JciklIjIkKa4U4OOG4WWg"}, node_locale: {eq: "en-US"}) {
    pages {
      id
      node_locale
      title
      subPages {
        title
      }
    }
  }

  footerNavigation: contentfulPageList(id: {eq: "c4P5PmA3Xy0s6MEwU8wO2Ic"}, node_locale: {eq: "en-US"}) {
    pages {
      id
      node_locale
      title
      subPages {
        title
      }
    }
  }

  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  news: allContentfulNewsArticle(limit: 1000) {
    edges {
      node {
        id
        heading
        body {
          body
        }
        node_locale
      }
    }
  }

  allPages: allContentfulPage {
    edges {
      node {
        id
        title
        subPages {
          id
          title
        }
        subPage
        node_locale
        hero {
          heading
          body {
            body
          }
        }
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/layouts/en.js